module.exports = __webpack_public_path__ + "img/miniapp-preview-02.d197e4f9.jpg";